import type { Product, Service } from '@/types';

type ProductTemplate = Omit<Product, 'id' | 'created_at' | 'updated_at'>;
type ServiceTemplate = Omit<Service, 'id' | 'created_at' | 'updated_at'>;

const productTemplate = (
  sku: string,
  name: string,
  category: ProductTemplate['category'],
): ProductTemplate => ({
  sku,
  name,
  category,
  cost_price: 0,
  selling_price: 0,
  current_stock: 0,
  min_stock_level: 0,
  tax_rate: 0,
  is_active: true,
  is_catalog_template: true,
  batch_tracking_enabled: category === 'tires' || category === 'used_tires',
});

export const REQUIRED_CATALOG_PRODUCTS: ProductTemplate[] = [
  productTemplate('USED-TIRE', 'Used Tire', 'used_tires'),
  productTemplate('USED-WHEEL', 'Used Wheel', 'used_wheels'),
  productTemplate('CONS-TIRE-TUBE', 'Tire Tube', 'consumables'),
  productTemplate('CONS-TIRE-VALVE', 'Tire Valve', 'consumables'),
  productTemplate('CONS-WHEEL-WEIGHTS', 'Wheel Weights', 'consumables'),
  productTemplate('CONS-TIRE-PLUG', 'Tire Plug', 'consumables'),
  productTemplate('CONS-PATCH-MATERIALS', 'Tire Patch Materials', 'consumables'),
  productTemplate('ACC-WIPER-BLADES', 'Wiper Blades', 'accessories'),
  productTemplate('ACC-FLOOR-MATS', 'Floor Mats', 'accessories'),
  productTemplate('ACC-PHONE-HOLDERS', 'Phone Holders', 'accessories'),
  productTemplate('ACC-SEAT-COVERS', 'Seat Covers', 'accessories'),
  productTemplate('ACC-STEERING-COVERS', 'Steering Wheel Covers', 'accessories'),
  productTemplate('ACC-AIR-FRESHENERS', 'Air Fresheners', 'accessories'),
  productTemplate('ACC-LED-BULBS', 'LED Bulbs', 'accessories'),
  productTemplate('ACC-HALOGEN-BULBS', 'Halogen Bulbs', 'accessories'),
  productTemplate('ACC-FUSES', 'Fuses', 'accessories'),
  productTemplate('ACC-TIRE-PRESSURE-GAUGES', 'Tire Pressure Gauges', 'accessories'),
  productTemplate('ACC-CAR-CHARGERS', 'Car Chargers', 'accessories'),
  productTemplate('ACC-JUMPER-CABLES', 'Jumper Cables', 'accessories'),
  productTemplate('ACC-WHEEL-COVERS', 'Wheel Covers', 'accessories'),
  productTemplate('ACC-CLEANING-PRODUCTS', 'Cleaning Products', 'accessories'),
  productTemplate('ACC-EMERGENCY-KITS', 'Emergency Kits', 'accessories'),
  productTemplate('OTHER-ITEM', 'Other Item', 'other'),
];

export const REQUIRED_TIRE_SERVICES: ServiceTemplate[] = [
  { code: 'SVC-TPATCH', name: 'Tire Patch', category: 'tire_service', price: 5, duration_min: 15, is_active: true },
  { code: 'SVC-TUBE-INSTALL', name: 'Tire Tube Installation', category: 'tire_service', price: 8, duration_min: 20, is_active: true },
  { code: 'SVC-VALVE', name: 'Tire Valve Replacement', category: 'tire_service', price: 3, duration_min: 10, is_active: true },
  { code: 'SVC-MOUNT', name: 'Tire Mounting', category: 'tire_service', price: 5, duration_min: 10, description: 'Per tire', is_active: true },
  { code: 'SVC-DISMOUNT', name: 'Tire Dismounting', category: 'tire_service', price: 3, duration_min: 10, description: 'Per tire', is_active: true },
  { code: 'SVC-BAL', name: 'Wheel Balancing', category: 'tire_service', price: 5, duration_min: 10, description: 'Per wheel', is_active: true },
  { code: 'SVC-ROT', name: 'Tire Rotation', category: 'tire_service', price: 12, duration_min: 15, is_active: true },
  { code: 'SVC-NITROGEN', name: 'Nitrogen Fill', category: 'tire_service', price: 2, duration_min: 10, description: 'Per tire', is_active: true },
];
